import {newGuid} from "tools/guid";
import Settings from 'settings';
import {Api} from 'tools/api';

export function getDescriptions(){
	return [
		{
			url: '/dashboards/new',
			getModuleImport: () => import('./designer'),
			params: {
				mode: 'designer'
			},
			routeId: 'board_new'
		},
		{
			url: '/dashboards/:id/designer',
			getModuleImport: () => import('./designer'),
			params: {
				mode: 'designer'
			},
			routeId: 'board_designer'
		},
		{
			url: '/dashboards/:id',
			getModuleImport: () => import('./designer'),
			params: {
				mode: 'viewer'
			},
			routeId: 'board_viewer'
		},
		{
			url: '/dashboards',
			getModuleImport: () => import('./pages/DashboardsPage'),
			routeId: 'board'
		}
	];
}

export class DashboardsRouter {
	static list(){
		return '#/dashboards';
	}

	static viewer(id) {
		sessionStorage.setItem('isCurrentHomeDashboard', false);
		return `/dashboards/${id}`;
	}

	static designer(id) {
		sessionStorage.setItem('isCurrentHomeDashboard', false);
		return `#/dashboards/${id}/designer`;
	}

	static create() {
		return `#/dashboards/new`;
	}

	static guestMode(id){
		return `#/dashboards/${id}?guestMode=1&standalone=1&sessionId=${newGuid()}`
	}

	static standalone(id, sessionId = null){
		return `/dashboards/${id}?standalone=1&sessionId=${sessionId ?? newGuid()}`
	}

	static getPropertiesUrl(id) {
		return Api.serverRoot() + 'dashboards/' + id + '/properties'
	}

	static publicUrl(id) {
		return location.protocol + '//' + location.host + Settings.httpRoot + 'dashboard/' + id;
	}

	static exportDashboard(id) {
		return Api.serverRoot() + 'dashboards/' + id + '/export';
	}

	static exportCSV(csvId) {
		return Api.serverRoot() + 'sessions/exportCSV/' + csvId
	}

	static importDashboard(accountId) {
		return Api.accountRoot(accountId) + 'dashboards/import';
	}
}
